import { CommonApiToManageUsersService, UserResponse } from "../../../generated/api";

export class UsersRepository {
  constructor(private readonly usersService: CommonApiToManageUsersService) {}

  readCurrent(): Promise<UserResponse> {
    return this.usersService.get8();
  }
}